module.exports = __webpack_public_path__ + "static/media/12_Bild_1_ARM_Team_DIPO-Power_NicolaPitaro_7667.9993cc9e.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle12/12_Bild_1_ARM_Team_DIPO-Power_NicolaPitaro_7667.jpg
 ** module id = 148
 ** module chunks = 0
 **/